'use strict';

var forEach = require('../utils/foreach');

forEach(document.querySelectorAll('.js-toggle-form'), function(toggle) {
    toggle.addEventListener('click', function(e) {
        e.preventDefault();

        history.pushState(null, null, toggle.getAttribute('href'));

        forEach(document.querySelectorAll('.js-edit-colleague'), function(form) {
            form.classList.remove('is-active');
        });

        document.querySelector(toggle.getAttribute('href')).classList.toggle('is-active');
    });
});
